import { AdminOrderBonusesState } from '@/store/modules/adminOrderBonuses/types';

const state: AdminOrderBonusesState = {
  bonus: undefined,
  bonusesCollection: [],
  availableSalesCampaignBonusesCollection: undefined,
};

export default state;
